import { render, staticRenderFns } from "./shop-cart.vue?vue&type=template&id=25035bb9&scoped=true"
import script from "./shop-cart.vue?vue&type=script&lang=js"
export * from "./shop-cart.vue?vue&type=script&lang=js"
import style0 from "./shop-cart.vue?vue&type=style&index=0&id=25035bb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25035bb9",
  null
  
)

export default component.exports